import React from 'react';

import { faUser as faRegUser } from '@fortawesome/free-regular-svg-icons/faUser';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { faHorseHead } from '@fortawesome/free-solid-svg-icons/faHorseHead';
import { faCog  } from '@fortawesome/free-solid-svg-icons/faCog';
import { faFlask } from '@fortawesome/free-solid-svg-icons/faFlask';
import { faScroll } from '@fortawesome/free-solid-svg-icons/faScroll';
import { faAd } from '@fortawesome/free-solid-svg-icons/faAd';
import NavListItem from './NavListItem.jsx';

const links = [
  {
    to: '/admin/users',
    icon: faRegUser,
    label: 'Users',
    links: [
      { to: '/admin/users/admins', icon: faUserTie, label: 'Admins' },
      // {
      //   to: '/admin/users/clients',
      //   icon: faUser,
      //   label: 'Clients',
      // },
    ],
  },
  { to: '/admin/players', icon: faUser, label: 'Players' },
  { to: '/admin/banners', icon: faFileSignature, label: 'Banners' },
  { to: '/admin/badges', icon: faFileSignature, label: 'Badges' },
  { to: '/admin/locations', icon: faFileSignature, label: 'Race Locations' },
  { to: '/admin/races', icon: faFileSignature, label: 'Races' },

  { to: '/admin/pics', icon: faFileSignature, label: 'Pics' },
  { to: '/admin/horses', icon: faHorseHead, label: 'Horses' },
  { to: '/admin/trades', icon: faHorseHead, label: 'Trades' },
  { to: '/admin/breeds', icon: faHorseHead, label: 'Breeds' },
  { to: '/admin/shares', icon: faHorseHead, label: 'Shares' },
  { to: '/admin/trainings', icon: faHorseHead, label: 'Trainings' },
  { to: '/admin/items', icon: faFlask, label: 'Items' },
  { to: '/admin/ads', icon: faAd, label: 'Ads' },
  { to: '/admin/blockchain-transactions', icon: faFlask, label: 'Blockchain transactions' },
  { to: '/admin/paymentRecords', icon: faScroll, label: 'Payment Records' },
  {
    icon: faCog,
    label: 'Admin',
    links: [
      { to: '/admin/operations', label: 'Operations' },
      { to: '/admin/config', label: 'Config' },
    ]
  },
  {
    href: '/logout',
    icon: faPowerOff,
    label: 'Logout',
  },
];

const Nav = () => (
  <nav className="col main-nav bg-light pr-0 py-5">
    <div className="nav flex-column pl-3">
      {links.map((l, i) => (
        <NavListItem key={i} {...l}>
          {l.links && (
            l.links.map((ll, ii) => (
              <NavListItem key={ii} {...ll} />
            ))
          )}
        </NavListItem>
      ))}
    </div>
  </nav>
);

export default Nav;
